import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  forceRound,
  getLowerCaseString,
  loadCss,
} from "../../helpers/function";
import LoadingTable from "../components/LoadingTable";
import { ToastBottomEnd } from "../components/Toast";
import {
  toastDeleteErrorMessageConfig,
  toastDeleteSuccessMessageConfig,
  toastEditSuccessMessageConfig,
  toastErrorMessageWithParameterConfig,
} from "../../config/toastConfig";
import HeaderTablePage from "../components/HeaderTablePage";
import { ERROR_401 } from "../../config/errorPage";
import { verifyPermission } from "../../helpers/permission";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import { useTranslation } from "react-i18next";
import InfirmationTable from "../components/InfirmationTable";
import InstitutionSelector from "../../components/configs/receipt/InstitutionSelector";
import appConfig from "../../config/appConfig";
import { set } from "react-hook-form";
import { cleanData } from "jquery";

loadCss("/assets/plugins/custom/datatables/datatables.bundle.css");

const endPointConfig = {
  PRO: {
    plan: "PRO",
    list: `${appConfig.apiDomaine}/my/processing-circuits`,
  },
  MACRO: {
    holding: {
      list: `${appConfig.apiDomaine}/any/processing-circuits`,
    },
    filial: {
      list: `${appConfig.apiDomaine}/my/processing-circuits`,
    },
  },
  HUB: {
    plan: "HUB",
    list: `${appConfig.apiDomaine}/without-institution/processing-circuits`,
  },
};

const ConfigReceipt = (props) => {
    //usage of useTranslation i18n
    const { t, ready } = useTranslation();

    const defaultError = {
        institution_id: [],
        enabled: [],
        entete: [],
        download_receipt_delay: [],
        treatment_delay: [],
    };

    const defaultData = {
        institution_id: "",
        enabled: false,
        entete: "",
        download_receipt_delay: 0,
        treatment_delay: "",
    };


    const [institutionData, setInstitutionData] = useState(undefined);
    const [institution, setInstitution] = useState(null);
    const [error, setError] = useState(defaultError);
    const [loading, setLoading] = useState(true);
    const [loading1, setLoading1] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const [data, setData] = useState(defaultData);
    const [isFilial, setIsFilial] = useState(false);

    const getEndpoint = useCallback(() => {
        let endPoint = "";
        if (props.plan === "MACRO") {
            if (
                verifyPermission(
                props.userPermissions,
                "update-processing-circuit-any-institution"
                )
            ) {
                endPoint = endPointConfig[props.plan].holding;
            } else if (
                verifyPermission(
                    props.userPermissions,
                    "update-processing-circuit-my-institution"
                )
            ) {
                endPoint = endPointConfig[props.plan].filial;
            }
        } else {
            endPoint = endPointConfig[props.plan];
        }
        return endPoint;
    }, [props.plan, props.userPermissions]);

    const institutionGetReceiptEndpoint = `${appConfig.apiDomaine}/show-receipt-configuration`;
    const institutionUpdateReceiptEndpoint = `${appConfig.apiDomaine}/edit-receipt-configuration`;

    const loadInstitutionReceiptData = async (instId) => {
        if (!verifyTokenExpire()) return;

        try {
            const response = await axios.get(`${institutionGetReceiptEndpoint}/${instId}`);
            setData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading1(false);
        }
    };

    const validate = async() => {
        setError(defaultError);
        if (!data.institution_id) {
            setError((prevState) => ({
                ...prevState,
                institution_id: ["Veuillez choisir une institution"],
            }));
        }
        if(!data.entete) {
            setError((prevState) => ({
                ...prevState,
                entete: ["Champs obligatoire"],
            }));
        }
        if(!data.download_receipt_delay) {
            setError((prevState) => ({
                ...prevState,
                download_receipt_delay: ["Champs obligatoire"],
            }));
        }
        if(!data.treatment_delay) {
            setError((prevState) => ({
                ...prevState,
                treatment_delay: ["Champs obligatoire"],
            }));
        }

        Object.keys(error).forEach((key) => {
            if (error[key].length > 0) {
                console.log(error[key]);
                return false;
            }
        })
        return true;
    };

    const cleanData = () => {
        setData(defaultData);
        setError(defaultError);
    };

    const onChange = (e) => {
        const newData = { ...data };
        newData[e.target.name] = e.target.value;
        setData(newData);
    };

    const formatFormData = (newData) => {
        const formData = new FormData();
        formData.append("_method", "post");
        for (const key in newData) {
            if (key === "file") {
                formData.append("file", newData.file);
            } else
                formData.set(key, newData[key]);
        }
        return formData;

    };

    const onChangeFile = (e) => {
        const newData = { ...data };
        newData.entete = Object.values(e.target.files)[0];
        setData(newData);
    }

    const onChangeInstitution = (selected) => {
        const institution_id = selected;
        setInstitution(institution_id);
        cleanData();
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!verifyTokenExpire()) return;

            const endPoint = getEndpoint();
            const endpointLocal = `${appConfig.apiDomaine}/edit-receipt-configuration`;

            try {
                setLoading(true);

                const response = await axios.get(endpointLocal);
                const options = response.data.institutions.length
                    ? response.data.institutions.map((institution) => ({
                        value: institution.id,
                        label: institution.name,
                    }))
                    : [];
                    setInstitutionData([options]);
                
                if(response.data.institutionType === "filiale") {
                    setIsFilial(true);

                    var institutionTemp = null
                    for (let i = 0; i < response.data.institutions.length; i++) {
                        if(response.data.institutions[i].id === response.data.institution_id) {
                            institutionTemp = {
                                value: response.data.institutions[i].id,
                                label: response.data.institutions[i].name
                            };
                            break;
                        }
                    }
                    setInstitution(institutionTemp);
                }
                

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (institution) {
            const newData = { ...data };
            newData.institution_id = institution.value;
            setData(newData);
            setLoading1(true);

            // Load data for the selected institution
            loadInstitutionReceiptData(institution.value);
        }
    }, [institution]);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoadingButton(true);
        if (!verifyTokenExpire()) return;

        if(!validate()) {
            setLoadingButton(false);
            return;
        } else {
            setError(defaultError);

            var tempData = {...data};
            if(data.entete && typeof data.entete == "string") delete tempData.entete;
            try {
                await axios.post(`${institutionUpdateReceiptEndpoint}/${institution.value}`, formatFormData(tempData));
                ToastBottomEnd.fire(toastEditSuccessMessageConfig());
                setLoadingButton(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                ToastBottomEnd.fire(toastErrorMessageWithParameterConfig("Erreur lors de la mise à jour"));
                setLoadingButton(false);
            }
        }
    }
    

    return (
        <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
            id="kt_content"
        >
            <div className="kt-subheader   kt-grid__item" id="kt_subheader">
                <div className="kt-container  kt-container--fluid ">
                    <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">{t("Paramètres")}</h3>
                    <span className="kt-subheader__separator kt-hidden" />
                    <div className="kt-subheader__breadcrumbs">
                        <a href="#icone" className="kt-subheader__breadcrumbs-home">
                        <i className="flaticon2-shelter" />
                        </a>
                        <span className="kt-subheader__breadcrumbs-separator" />
                        <a
                            href="#button"
                            onClick={(e) => e.preventDefault()}
                            className="kt-subheader__breadcrumbs-link"
                            style={{ cursor: "text" }}
                        >
                        {t("Configurations récépissés ")}
                        </a>
                    </div>
                    </div>
                </div>
            </div>

            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                <InfirmationTable
                    information={t(
                        "Paramètre de configuration des récepissés"
                    )}
                />

                <div className="kt-portlet">
                    <HeaderTablePage
                        addPermission=""
                        title={t("Configuration des récepissés")}
                    />

                    {
                        loading ? <LoadingTable/>
                        : (
                            <div className="kt-portlet__body">
                                <div
                                    id="kt_table_1_wrapper"
                                    className="dataTables_wrapper dt-bootstrap4"
                                >
                                    {
                                        !isFilial ?
                                        <InstitutionSelector
                                            userPermissions={props.userPermissions}
                                            institutionData={institutionData}
                                            institution={institution}
                                            onChangeInstitution={onChangeInstitution}
                                            error={error}
                                            t={t}
                                        />
                                        : ""
                                    }
                                    <br />
                                </div>
                            </div>
                        )
                    }

                    {
                        institution ? loading1 ? <LoadingTable/> : (
                            <form onSubmit={onSubmit}>
                                <div className="kt-portlet__body">
                                    <div
                                        id="kt_table_1_wrapper"
                                        className="dataTables_wrapper dt-bootstrap4"
                                    >
                                        <div>
                                            {/* <div className="form-group row">
                                                <label className="col-form-label col-lg-3 col-sm-12">
                                                    {t("Information de la banque")}
                                                </label>
                                                <div className="col-lg-9 col-md-9 col-sm-12">
                                                    <textarea
                                                        className="form-control"
                                                        name="bank_info"
                                                        onChange={onChange}
                                                        value={data.bank_info}
                                                        style={{whiteSpace: 'pre-wrap'}}
                                                        rows={6}
                                                        placeholder={`Orabank succursale Orabank Côte d'Ivoire - 1416, avenue Kwame N'Krumah
01 BP 1305 Ouagadougou 01 - Burkina Faso
Tél. : (+226) 25 49 60 00 - Fax : (+226) 25 30 34 80
www.orabank.net - Plaintes & Réclamations: (+226) 71 20 21 21 / reclamationsOBF@orabank.net
S.A. au capital de 49.443.750.000 F CFA - R.C.C.M : BF OUA 2021 M 0738 - IFU : 00053615 H - Swift ORBKBFBF`}
                                                        />
                                                </div>
                                            </div> */}

                                            <div className="form-group row">
                                                <label className="col-form-label col-lg-3 col-sm-12">
                                                    {t("Entête")} <span className="text-danger">(Max: 2Mo - jpg, jpeg, png)</span>
                                                </label>
                                                <div className="col-lg-9 col-md-9 col-sm-12">
                                                    <input 
                                                        type="file" 
                                                        className="form-control" 
                                                        name="entete" 
                                                        onChange={onChangeFile}
                                                    />
                                                    {data.entete && <a className="d-block mt-2" href={appConfig.apiDomaine+'/storage'+data.entete} target="_blank">Visualiser l'entête</a> }
                                                    {
                                                        error.entete.length ? (
                                                            <span className="form-text text-danger">
                                                                {error.entete}
                                                            </span>
                                                        ) : ""
                                                    }
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-form-label col-lg-3 col-sm-12">
                                                    {t("Délai de téléchargement du récépissé (en jours)")}
                                                </label>
                                                <div className="col-lg-9 col-md-9 col-sm-12">
                                                    <input
                                                        name="download_receipt_delay"
                                                        type="number"
                                                        className="form-control"
                                                        onChange={onChange}
                                                        value={data.download_receipt_delay}
                                                        placeholder="Ex: 3"
                                                        required
                                                    />
                                                    {
                                                        error.download_receipt_delay.length ? (
                                                            <span className="form-text text-danger">
                                                                {error.download_receipt_delay}
                                                            </span>
                                                        ) : ""
                                                    }
                                                </div>
                                            </div>

                                            {/* <div className="form-group row">
                                                <label className="col-form-label col-lg-3 col-sm-12">
                                                    {t("Information de contact")}
                                                </label>
                                                <div className="col-lg-9 col-md-9 col-sm-12">
                                                    <textarea
                                                        className="form-control"
                                                        name="contact_info"
                                                        onChange={onChange}
                                                        value={data.contact_info}
                                                        placeholder="Ex: Tél. : (+226) 00 00 00 00 - Fax : (+226) 00 00 00 00, www.orabank.net , Plaintes & Réclamations : (+226) 00 00 00 00 / reclamationsOBF@orabank.net"
                                                    ></textarea>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-form-label col-lg-3 col-sm-12">
                                                    {t("Mention légale")}
                                                </label>
                                                <div className="col-lg-9 col-md-9 col-sm-12">
                                                    <textarea
                                                        className="form-control"
                                                        name="legal_info"
                                                        onChange={onChange}
                                                        value={data.legal_info}
                                                        placeholder="Ex : Tél. : S.A. au capital de 49.443.750.000 F CFA - R.C.C.M : BF OUA 2021 M 0738 - IFU : 00053615 H - Swift ORBKBFBF"
                                                    ></textarea>
                                                </div>
                                            </div> */}
                                            
                                            <div className="form-group row">
                                                <label className="col-form-label col-lg-3 col-sm-12">
                                                    {t("Délai Approximatif de traitement")}
                                                </label>
                                                <div className="col-lg-9 col-md-9 col-sm-12">
                                                   <input
                                                        className="form-control"
                                                        type="text" 
                                                        name="treatment_delay" 
                                                        onChange={onChange} 
                                                        value={data.treatment_delay}
                                                        placeholder="Ex: Délai de réponse des réclamations / Plaintes : Un (1) mois à compter de la date de dépôt"
                                                    />
                                                    {
                                                        error.treatment_delay.length ? (
                                                            <span className="form-text text-danger">
                                                                {error.treatment_delay}
                                                            </span>
                                                        ) : ""
                                                    }
                                                </div>
                                            </div>

                                            {/*<div className="d-flex col-md-6 mb-4 order-1 order-md-2">
                                                <span className="kt-switch order-2 order-md-1">
                                                    <label>
                                                        <input
                                                            id="enabled"
                                                            type="checkbox"
                                                            checked={(data.enabled === true || data.enabled === "1") ? true : false}
                                                            onChange={(e) => { setData({ ...data, enabled: e.target.checked ? "1" : "0" }) }}
                                                        />
                                                        <span />
                                                    </label>
                                                </span>
                                                <label className="ml-md-4 mr-4 mr-md-0 col-form-label order-1 order-md-2">
                                                    {t("Autorisé l'impression de récepisse pour cette filiale")}{" "}
                                                </label>
                                            </div>*/}
                                        </div>
                                    </div>
                                </div>

                                <div className="kt-portlet__foot">
                                    <div className="kt-form__actions">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <button
                                                    type="submit"
                                                    disabled={loadingButton}
                                                    className="btn btn-primary"
                                                >
                                                    {loadingButton && (
                                                        <span className="spinner-border spinner-border-sm m-0"></span>
                                                    )}
                                                    {t("Modifier")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </form>
                        ) : null
                    }
                    

                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
    language: state.language.languageSelected,
    plan: state.plan.plan,
  };
};

export default connect(mapStateToProps)(ConfigReceipt);